import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledHero = styled.section`
	background-color: ${CSSVars.gray700};
	padding: 50px 20px 50px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 160px 40px 100px;
	}

	.hero-content-container {
		max-width: 1420px;
		margin: 0 auto;
		color: ${CSSVars.white};
		text-align: center;
		position: relative;

		.icons-img {
			position: absolute;

			&.right {
				transform: scale(0.3);
				left: 50%;
				top: 125px;
				display: none;
				height: 100%;

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					transform: scale(0.7);
					display: block;
					left: 75%;
					top: -50px;
				}

				@media screen and (min-width: ${CSSVars.breakpointXL}) {
					left: 80%;
				}

				@media screen and (min-width: ${CSSVars.breakpoint2XL}) {
					transform: scale(1);
					left: 90%;
				}
			}

			&.middle {
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%) scale(0.5);
				display: none;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					display: block;
					transform: translate(-50%, -50%) scale(1);
				}

				@media screen and (min-width: ${CSSVars.breakpoint2XL}) {
					transform: translate(-50%, -50%) scale(1);
				}
			}

			&.left {
				transform: scale(0.3);
				opacity: 0;
				display: none;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					display: block;
					opacity: 1;
					transform: scale(0.5);
					top: 50px;
					right: 75%;
				}

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					top: -100px;
					right: 79%;
				}

				@media screen and (min-width: ${CSSVars.breakpointXL}) {
					transform: scale(0.7);
				}

				@media screen and (min-width: ${CSSVars.breakpoint2XL}) {
					transform: scale(1);
					right: 89%;
				}
			}
		}

		h1 {
			font-weight: 600;
			max-width: 800px;
			margin: 0 auto;
			position: relative;
			z-index: 10;

			font-size: ${CSSVars.fontSize2XL};
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
				font-size: ${CSSVars.fontSize3XL};
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize4XL};
				max-width: 750px;
			}

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				font-size: ${CSSVars.fontSize6XL};
			}

			span {
				color: ${CSSVars.primary500};
			}
		}

		h2 {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeLG};
			position: relative;
			z-index: 10;

			text-align: left;
			margin: 20px auto 40px;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 850px;
				font-size: ${CSSVars.fontSizeXL};
			}

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				margin: 30px auto 50px;
				max-width: 930px;
			}

			span {
				color: ${CSSVars.primary500};
			}
		}

		.search-box-wrapper {
			margin: 0 auto;
		}

		form {
			position: relative;
			z-index: 10;
			width: 100%;
		}
	}
`;
